// src/components/Landing/LandingPage.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'; // Add axios import
import { useUserContext } from '../../contexts/UserContext'; // Add UserContext import
import './CompleteLandingPage.css';
import SystemCarousel from './SystemCarousel'; // Importação do componente de carrossel

// Removido a definição de API_URL conforme instruções
const API_URL = process.env.REACT_APP_API_URL || 'http://http://https://southamerica-east1-drecenna.cloudfunctions.net/api';

// Componente do modal do Calendly extraído como componente separado
// para evitar o erro de Hooks condicionais
const CalendlyModal = ({ onClose }) => {
  const modalRef = useRef(null);
  const calendlyRef = useRef(null);
  
  // Usar useEffect para garantir que o Calendly seja inicializado apenas uma vez
  useEffect(() => {
    if (calendlyRef.current) {
      try {
        // Injetar o iframe do Calendly diretamente
        calendlyRef.current.innerHTML = `
          <iframe src="https://calendly.com/fabricio-venturi/new-meeting" 
                 frameborder="0" 
                 width="100%" 
                 height="100%"
                 title="Calendly"
                 allowtransparency="true"></iframe>
        `;
      } catch (error) {
        console.error("Erro ao injetar iframe do Calendly:", error);
      }
    }
    
    return () => {
      // Limpar o conteúdo ao desmontar
      if (calendlyRef.current) {
        calendlyRef.current.innerHTML = '';
      }
    };
  }, []);

  // Click fora do modal para fechar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Função para escapar do modal com tecla ESC
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEscape);
    
    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);
  
  return (
    <div className="lp-calendly-modal">
      <div className="lp-calendly-modal-content" ref={modalRef}>
        <button 
          className="lp-calendly-close" 
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
        <div className="lp-calendly-iframe-container" ref={calendlyRef}>
          {/* O iframe será injetado aqui via useEffect */}
        </div>
      </div>
    </div>
  );
};

// Email input component for the pricing section
const EmailInputModal = ({ isOpen, onClose, onSubmit, loading, emailError }) => {
  const [email, setEmail] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsError, setTermsError] = useState('');
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      window.addEventListener('keydown', handleEscape);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      setEmail('');
      setAcceptedTerms(false);
      setTermsError('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    // Clear previous errors
    setTermsError('');
    
    // Validate terms acceptance
    if (!acceptedTerms) {
      setTermsError('Você deve aceitar os termos de serviço para continuar');
      return;
    }
    
    // Call the original submit function
    onSubmit(email);
  };

  if (!isOpen) return null;

  return (
    <div className="lp-calendly-modal">
      <div className="lp-calendly-modal-content" ref={modalRef} style={{ maxWidth: '500px', height: 'auto', padding: '2rem' }}>
        <button 
          className="lp-calendly-close" 
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
        <h2 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>Informe seu email para continuar</h2>
        
        <div style={{ marginBottom: '1.5rem' }}>
          <input
            type="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: emailError ? '1px solid #f44336' : '1px solid #ddd',
              fontSize: '16px',
              marginBottom: emailError ? '8px' : '0'
            }}
          />
          {emailError && (
            <div style={{ color: '#f44336', fontSize: '14px' }}>{emailError}</div>
          )}
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            gap: '8px', 
            cursor: 'pointer',
            fontSize: '14px',
            lineHeight: '1.4'
          }}>
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              style={{
                marginTop: '2px',
                cursor: 'pointer'
              }}
            />
            <span>
              Li e aceito os{' '}
              <a 
                href="/terms" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  color: '#4285f4', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
              >
                termos de serviço
              </a>
            </span>
          </label>
          {termsError && (
            <div style={{ color: '#f44336', fontSize: '12px', marginTop: '4px' }}>{termsError}</div>
          )}
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: loading ? '#ccc' : '#4285f4',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? '0.7' : '1'
          }}
        >
          {loading ? 'Processando...' : 'Continuar'}
        </button>
      </div>
    </div>
  );
};

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Removido o estado activeTab já que não teremos mais a opção anual
  const [showCalendlyModal, setShowCalendlyModal] = useState(false);
  
  // User authentication context
  const { user, isAuthenticated } = useUserContext();
  
  // State for direct checkout process
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [checkoutError, setCheckoutError] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      if (scrolled !== isVisible) {
        setIsVisible(scrolled);
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lp-animate-in');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.lp-animate-on-scroll').forEach(element => {
      observer.observe(element);
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, [isVisible]);

  // Removido o useEffect do contador animado - agora os valores são fixos

  // Efeito para controlar o overflow do body quando o modal está aberto
  useEffect(() => {
    if (showCalendlyModal || showEmailModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showCalendlyModal, showEmailModal]);

  // Função togglePricingTab removida pois não é mais necessária

  // Função melhorada para abrir o modal com segurança
  const handleScheduleMeeting = (e) => {
    e.preventDefault();
    // Colocar um pequeno delay para evitar problemas de estado
    setTimeout(() => {
      setShowCalendlyModal(true);
    }, 50);
  };

  // Função para fechar o modal com segurança
  const closeCalendlyModal = () => {
    setShowCalendlyModal(false);
  };

  // Função para iniciar processo de checkout direto
  const handleDirectCheckout = (planType) => {
    setCheckoutError(''); // Limpar erros anteriores
    
    // If user is already authenticated, use their email
    if (isAuthenticated && user?.email) {
      handleSubscribe(planType, user.email);
    } else {
      // Otherwise, show email input modal
      setSelectedPlan(planType);
      setEmailError('');
      setShowEmailModal(true);
    }
  };

  // Function to close email modal
  const closeEmailModal = () => {
    setShowEmailModal(false);
    setSelectedPlan(null);
    setEmailError('');
  };

  // Email validation function (copied from Pricing.js)
  const validateEmail = (emailToValidate) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(emailToValidate);
  };

  // Function to handle subscription after email input
  const handleEmailSubmit = (email) => {
    if (!email) {
      setEmailError('Por favor, informe seu email');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Por favor, informe um email válido');
      return;
    }

    handleSubscribe(selectedPlan, email);
  };

  // Function to create checkout session (similar to Pricing.js)
  const handleSubscribe = async (planType, email) => {
    if (!email) {
      setEmailError('Por favor, informe seu email');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Por favor, informe um email válido');
      return;
    }

    setEmailError('');
    setCheckoutError('');
    setLoading(true);

    try {
      // Usando fetch diretamente ao invés do axios para evitar qualquer configuração global
      // que possa estar influenciando a URL base
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          planType,
          email,
          // Add renewal flag if user is authenticated
          isRenewal: isAuthenticated
        }),
      });

      // Se a resposta não for ok, tenta ler o corpo de erro
      if (!response.ok) {
        // Tentar obter mais detalhes do erro
        let errorDetails = '';
        try {
          const errorData = await response.json();
          errorDetails = errorData.error || errorData.message || '';
          console.error('Resposta de erro:', errorData);
        } catch (jsonError) {
          // Se não conseguir ler o JSON, usa a mensagem de status
          errorDetails = response.statusText;
        }
        
        throw new Error(`Erro na requisição (${response.status}): ${errorDetails}`);
      }

      const data = await response.json();
      console.log('Resposta de checkout recebida:', data);
      
      // Redirect to Stripe checkout
      window.location.href = data.url;
    } catch (error) {
      console.error('Erro detalhado ao iniciar checkout:', error);
      setCheckoutError(error.message || 'Ocorreu um erro ao processar seu pedido. Por favor, tente novamente.');
      alert(`Erro ao iniciar o checkout: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-page-root">
      <div className="lp-container">
        <div className="lp-bg-gradient"></div>
        <div className="lp-bg-pattern"></div>
        <div className="lp-bg-shape lp-shape-1"></div>
        <div className="lp-bg-shape lp-shape-2"></div>
        <div className="lp-bg-shape lp-shape-3"></div>

        <nav className={`lp-nav ${isVisible ? 'lp-nav-scrolled' : ''}`}>
          <div className="lp-nav-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </div>
          <div className="lp-nav-links">
            <a href="#features" className="lp-nav-link">Funcionalidades</a>
            <a href="#pricing" className="lp-nav-link">Planos</a>
            
            <Link to="/tutorials" className="lp-nav-link">Como usar</Link>
            <Link to="/about" className="lp-nav-link">Sobre Nós</Link>
            <Link to="/agendar-demonstracao" className="lp-nav-link">Demonstração</Link>
            <a 
              href="https://wa.me/554137984531" 
              className="lp-nav-link lp-nav-whatsapp-link"
              target="_blank" 
              rel="noopener noreferrer"
            >
              Contato
            </a>
            
            <Link to="/login" className="lp-nav-btn lp-nav-login">
              <span>Entrar</span>
              <span className="lp-btn-icon">→</span>
            </Link>
          </div>
          <div className="lp-mobile-menu-toggle">
            <div className="lp-hamburger"></div>
          </div>
        </nav>
        <section className="lp-hero-section">
          <div className="lp-hero-content lp-animate-on-scroll">
            <h1 className="lp-glowing-text">
              <span className="lp-text-highlight">Controle financeiro</span> automático para seu negócio
            </h1>
            <p className="lp-hero-description">
              Simplifique sua gestão financeira, acompanhe receitas e despesas, e tome decisões
              baseadas em dados reais com nossa plataforma premiada.
            </p>
            <div className="lp-hero-buttons">
              <a href="#" onClick={handleScheduleMeeting} className="lp-btn lp-btn-primary">
                <span>Agende sua demonstração</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="24" height="24">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
              <a href="#pricing" className="lp-btn lp-btn-secondary">
                <span>Ver Planos</span>
              </a>
            </div>
          </div>
          <div className="lp-hero-image">
            <img src="/prints/dashboard.png" alt="Dashboard DRE Pro" className="lp-dashboard-preview lp-animate-on-scroll" />
          </div>
        </section>

        <section id="how-it-works" className="lp-how-it-works-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Simples e Eficiente</div>
            <h2>Como o DRE Pro Funciona</h2>
            <p>Três passos simples para transformar sua gestão financeira</p>
          </div>
          <div className="lp-steps-container">
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">1</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 12h8M12 8v8" />
                  </svg>
                </div>
                <h3>Importe suas transações</h3>
                <p>Adicione seus arquivos bancários com segurança e deixe que nossa plataforma cuide do resto.</p>
              </div>
            </div>
            <div className="lp-step-connector"></div>
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">2</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                  </svg>
                </div>
                <h3>Categorização Inteligente</h3>
                <p>Com uma categorização inicial simples e intuitiva, nossa IA aprende e passa a identificar e classificar automaticamente todas as suas transações, economizando horas de trabalho manual.</p>
              </div>
            </div>
            <div className="lp-step-connector"></div>
            <div className="lp-step-card lp-animate-on-scroll">
              <div className="lp-step-number">3</div>
              <div className="lp-step-content">
                <div className="lp-step-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <path d="M12 20V10M18 20V4M6 20v-6" />
                  </svg>
                </div>
                <h3>Análise e Decisão</h3>
                <p>Relatórios profissionais DRE atualizados em tempo real para fundamentar suas decisões de negócio.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Carrossel de capturas de tela do sistema */}
        <SystemCarousel />

        <section id="features" className="lp-features-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Recursos Exclusivos</div>
            <h2>Funcionalidades Poderosas</h2>
            <p>Ferramentas completas para otimizar sua gestão financeira</p>
          </div>
          <div className="lp-features-grid">
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <rect x="2" y="3" width="20" height="18" rx="2" />
                  <path d="M8 10h8M8 14h4" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Dashboard Intuitivo</h3>
                <p>Visualize seus dados financeiros em tempo real com gráficos interativos e análises dinâmicas.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v8M8 12h8" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Categorização Automática</h3>
                <p>Suas transações são automaticamente categorizadas, economizando tempo e organizando seus registros.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M12 20V10M18 20V4M6 20v-6" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Relatórios DRE</h3>
                <p>Relatórios completos de Demonstração de Resultados para decisões financeiras estratégicas.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <path d="M16 2v4M8 2v4M3 10h18" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Gestão de Períodos</h3>
                <p>Compare resultados financeiros entre diferentes períodos para identificar tendências.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <rect x="5" y="2" width="14" height="20" rx="2" />
                  <path d="M12 18h.01" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Cálculo Automático de Impostos</h3>
                <p>Deixe o trabalho pesado conosco e calcule seus impostos em segundos com total segurança e precisão.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
            <div className="lp-feature-card lp-animate-on-scroll">
              <div className="lp-feature-icon">
                <div className="lp-icon-bg"></div>
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <rect x="3" y="11" width="18" height="10" rx="2" />
                  <circle cx="12" cy="16" r="1" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
              </div>
              <div className="lp-feature-content">
                <h3>Segurança Avançada</h3>
                <p>Seus dados financeiros protegidos com as mais modernas tecnologias de segurança.</p>
              </div>
              <div className="lp-feature-hover">
                <span>Saiba mais</span>
                <svg className="lp-feature-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </div>
        </section>

        <section id="pricing" className="lp-pricing-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Transparência Total</div>
            <h2>Planos que se adaptam ao seu negócio</h2>
            <p>Escolha o plano ideal para suas necessidades</p>
          </div>
          
          {/* Removido o toggle de pricing */}
          
          {/* Exibir erro de checkout se existir */}
          {checkoutError && (
            <div style={{ 
              backgroundColor: '#ffebee', 
              border: '1px solid #ef5350',
              borderRadius: '4px',
              padding: '10px 15px',
              marginBottom: '20px',
              color: '#c62828',
              fontSize: '14px'
            }}>
              <strong>Erro:</strong> {checkoutError}
            </div>
          )}
          
          <div className="lp-pricing-plans lp-animate-on-scroll">
            <div className="lp-pricing-card">
              <div className="lp-card-header">
                <h3>Plano Pessoal</h3>
                <div className="lp-price">
                  <span className="lp-currency">R$</span>
                  <span className="lp-amount">99</span>
                  <span className="lp-period">/mês</span>
                </div>
                <p className="lp-card-description">Ideal para profissionais autônomos e pequenos negócios</p>
              </div>
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Acesso às funcionalidades básicas</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Uso para 1 usuário pessoa física</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Suporte via WhatsApp</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Importação de arquivos OFX</span>
                </div>
                <div className="lp-feature-item lp-faded">
                  <svg className="lp-check-icon lp-faded" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Relatórios avançados</span>
                </div>
                <div className="lp-feature-item lp-faded">
                  <svg className="lp-check-icon lp-faded" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Leitura detalhada das transações</span>
                </div>
              </div>
              <div className="lp-card-footer">
                <button 
                  onClick={() => handleDirectCheckout('personal')}
                  disabled={loading}
                  className="lp-btn lp-btn-outline"
                >
                  {loading ? 'Processando...' : (isAuthenticated ? 'Renovar Plano Pessoal' : 'Assinar Plano Pessoal')}
                </button>
              </div>
            </div>
            <div className="lp-pricing-card lp-popular">
              <div className="lp-card-badge">Mais Popular</div>
              <div className="lp-card-header">
                <h3>Plano Empresarial</h3>
                <div className="lp-price">
                  <span className="lp-currency">R$</span>
                  <span className="lp-amount">199</span>
                  <span className="lp-period">/mês</span>
                </div>
                <p className="lp-card-description">Perfeito para empresas em crescimento</p>
              </div>
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Todas as funcionalidades do plano Pessoal</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Possibilidade de averiguar os três últimos meses</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Suporte via WhatsApp prioritário</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Uso para uma conta bancária</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Centro de custos específico para empresas</span>
                </div>
                <div className="lp-feature-item lp-faded">
                  <svg className="lp-check-icon lp-faded" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Relatórios avançados </span>
                </div>
              </div>
              <div className="lp-card-footer">
                <button 
                  onClick={() => handleDirectCheckout('business')}
                  disabled={loading}
                  className="lp-btn lp-btn-primary"
                >
                  {loading ? 'Processando...' : (isAuthenticated ? 'Renovar Plano Empresarial' : 'Assinar Plano Empresarial')}
                </button>
              </div>
            </div>
            <div className="lp-pricing-card">
              <div className="lp-card-header">
                <h3>Plano Empresarial Pro</h3>
                <div className="lp-price">
                  <span className="lp-currency">R$</span>
                  <span className="lp-amount">399</span>
                  <span className="lp-period">/mês</span>
                </div>
                <p className="lp-card-description">Tenha todas as suas empresas em um só lugar. Uma conta, múltiplos CNPJs.</p>
              </div>
              <div className="lp-card-features">
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Todas as funcionalidades do plano Empresarial</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Possibilidade de averiguar os 2 últimos anos</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Inclua também sua conta pessoal, além das empresas.</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Uso de múltiplas contas bancárias</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Consultoria dedicada</span>
                </div>
                <div className="lp-feature-item">
                  <svg className="lp-check-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path d="M9 11l3 3L22 4" />
                  </svg>
                  <span>Comparação e cálculo automático de regimes tributários</span>
                </div>
              </div>
              <div className="lp-card-footer">
                <button 
                  onClick={() => handleDirectCheckout('business_pro')}
                  disabled={loading}
                  className="lp-btn lp-btn-outline"
                >
                  {loading ? 'Processando...' : (isAuthenticated ? 'Renovar Plano Empresarial Pro' : 'Assinar Plano Empresarial Pro')}
                </button>
              </div>
            </div>
          </div>
          <div className="lp-enterprise-option lp-animate-on-scroll">
            <div className="lp-enterprise-content">
              <h3>Precisa de um plano personalizado?</h3>
              <p>Para empresas com necessidades específicas, oferecemos soluções personalizadas.</p>
            </div>
            <a href="#" onClick={handleScheduleMeeting} className="lp-btn lp-btn-outline-light">
              Fale com nossa Equipe
            </a>
          </div>
          <div className="lp-pricing-faqs lp-animate-on-scroll">
            <h3>Perguntas Frequentes</h3>
            <div className="lp-faq-grid">
              <div className="lp-faq-item">
                <h4>Posso mudar de plano a qualquer momento?</h4>
                <p>Você tem total liberdade para fazer upgrade ou downgrade do seu plano a qualquer momento, com mudanças aplicadas de forma imediata para sua conveniência.</p>
              </div>
              <div className="lp-faq-item">
                <h4>O DRE Pro oferece período de teste?</h4>
                <p>Embora não ofereçamos período de teste gratuito, garantimos suporte completo para que você tenha a melhor experiência desde o início. Escolha o plano ideal para suas necessidades e conte com nossa equipe em cada passo!</p>
              </div>
              <div className="lp-faq-item">
                <h4>Existe alguma taxa de configuração?</h4>
                <p>Não cobramos nenhuma taxa de configuração. Sempre que precisar, nossos especialistas estão prontos para ajudar gratuitamente na configuração e no uso da plataforma, garantindo uma experiência simples e eficiente desde o começo.</p>
              </div>
              <div className="lp-faq-item">
                <h4>Quais formas de pagamento são aceitas?</h4>
                <p>Para sua comodidade e segurança, todos os nossos planos de assinatura são pagos exclusivamente via cartão de crédito.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="benefits" className="lp-benefits-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Resultados Reais</div>
            <h2>Benefícios para seu Negócio</h2>
            <p>Por que escolher o DRE Pro para sua gestão financeira</p>
          </div>
          <div className="lp-benefits-container">
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">01</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <h3>Economia de Tempo</h3>
              <p>Reduza horas de trabalho manual na organização financeira com nossos sistemas automatizados.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">85%</div>
                <div className="lp-stat-label">Menos tempo em tarefas manuais</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">02</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
                </svg>
              </div>
              <h3>Decisões Estratégicas</h3>
              <p>Tome decisões baseadas em dados com relatórios detalhados e análises precisas.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">3X</div>
                <div className="lp-stat-label">Mais informações para decisões</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">03</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M9 11l3 3L22 4" />
                  <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
                </svg>
              </div>
              <h3>Conformidade Fiscal</h3>
              <p>Mantenha seus registros organizados e facilite o cumprimento de obrigações fiscais.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">100%</div>
                <div className="lp-stat-label">Conformidade com a legislação</div>
              </div>
            </div>
            <div className="lp-benefit-card lp-animate-on-scroll">
              <div className="lp-benefit-number">04</div>
              <div className="lp-benefit-icon">
                <svg viewBox="0 0 24 24" width="32" height="32">
                  <path d="M13 7h8m-8 4h8m-8 4h8M3 7h2v10H3zM9 7H7v10h2z" />
                </svg>
              </div>
              <h3>Crescimento Sustentável</h3>
              <p>Identifique oportunidades de crescimento e controle seus custos de maneira eficiente.</p>
              <div className="lp-benefit-stat">
                <div className="lp-stat-value">22%</div>
                <div className="lp-stat-label">Média de redução de custos</div>
              </div>
            </div>
          </div>
        </section>

        <section id="testimonials" className="lp-testimonials-section">
          <div className="lp-section-header lp-animate-on-scroll">
            <div className="lp-section-badge">Casos de Sucesso</div>
            <h2>O Que Nossos Clientes Dizem</h2>
            <p>Histórias reais de empresas que transformaram sua gestão financeira com o DRE Pro</p>
          </div>
          <div className="lp-testimonials-container">
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"O DRE Pro transformou completamente a gestão financeira da minha empresa. Antes, gastávamos horas organizando planilhas, hoje tudo é automatizado e preciso. Conseguimos identificar áreas de melhoria que eram invisíveis antes."</p>
              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">JM</div></div>
                <div className="lp-author-info"><h4>Jocelito Mendes</h4><p>CEO da TechSolutions</p></div>
              </div>
            </div>
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"Com o DRE Pro, conseguimos identificar despesas desnecessárias que não estávamos monitorando. Economizamos 22% nos primeiros três meses de uso. O suporte é excepcional, sempre disponível para esclarecer qualquer dúvida."</p>
              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">MA</div></div>
                <div className="lp-author-info"><h4>Matheus Almeida</h4><p>Diretor Financeiro da Construviva</p></div>
              </div>
            </div>
            <div className="lp-testimonial-card lp-animate-on-scroll">
              <div className="lp-testimonial-rating">
                <span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span><span className="lp-star">★</span>
              </div>
              <div className="lp-testimonial-content">
                <p>"A facilidade de categorizar transações e gerar relatórios com o DRE Pro me ajudou a ter uma visão clara da saúde financeira do meu restaurante. As análises comparativas entre períodos são indispensáveis para o nosso planejamento."</p>
              </div>
              <div className="lp-testimonial-author">
                <div className="lp-author-avatar"><div className="lp-avatar-circle">EP</div></div>
                <div className="lp-author-info"><h4>Gabriel Pereira</h4><p>Proprietário do Sabor & Arte</p></div>
              </div>
            </div>
          </div>
        </section>

        <section className="lp-cta-section">
          <div className="lp-cta-background">
            <div className="lp-cta-shape lp-shape-1"></div><div className="lp-cta-shape lp-shape-2"></div><div className="lp-cta-shape lp-shape-3"></div>
          </div>
          <div className="lp-cta-content lp-animate-on-scroll">
            <div className="lp-cta-badge"><span>Comece Hoje Mesmo</span></div>
            <h2>Pronto para transformar a gestão financeira da sua empresa?</h2>
            <p>Junte-se aos milhares de negócios que já otimizaram seus processos financeiros com o DRE Pro.</p>
            <div className="lp-cta-features">
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Configuração rápida</span></div>
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Suporte especializado</span></div>
              <div className="lp-cta-feature"><svg className="lp-feature-check" viewBox="0 0 24 24" width="24" height="24"><path d="M9 11l3 3L22 4" /></svg><span>Resultados imediatos</span></div>
            </div>
            <div className="lp-cta-buttons">
              <a href="#" onClick={handleScheduleMeeting} className="lp-btn lp-btn-outline-light">
                <span>Agendar Demo</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="20" height="20"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </a>
              <a href="#pricing" className="lp-btn lp-btn-primary">
                <span>Ver Planos</span>
                <svg className="lp-btn-arrow" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </section>

        <footer className="lp-footer">
          <div className="lp-footer-content">
            <div className="lp-footer-logo">
              <img src="/logolandingpage.png" alt="DRE Pro Logo" className="lp-footer-logo-img" />
              <p>Gestão financeira inteligente para seu negócio</p>
              <div className="lp-social-icons">
                <a href="#" className="lp-social-icon"><span>FB</span></a><a href="#" className="lp-social-icon"><span>TW</span></a><a href="#" className="lp-social-icon"><span>IG</span></a><a href="#" className="lp-social-icon"><span>LI</span></a>
              </div>
            </div>
            <div className="lp-footer-links">
              <div className="lp-footer-column"><h4>Empresa</h4><Link to="/about">Sobre Nós</Link><Link to="/contact">Contato</Link></div>
              <div className="lp-footer-column"><h4>Produto</h4><a href="#features">Funcionalidades</a><a href="#pricing">Planos</a><a href="#benefits">Benefícios</a></div>
              <div className="lp-footer-column"><h4>Recursos</h4><a href="#">Central de Ajuda</a><Link to="/tutorials">Tutoriais</Link></div>
              <div className="lp-footer-column"><h4>Legal</h4><Link to="/terms">Termos de Serviço</Link><Link to="/privacy">Política de Privacidade</Link></div>
            </div>
          </div>
          <div className="lp-footer-newsletter">
            <h4>Receba novidades por email</h4>
            <div className="lp-newsletter-form">
              <input type="email" placeholder="Seu email" />
              <button className="lp-btn-subscribe">Inscrever-se</button>
            </div>
          </div>
          <div className="lp-footer-bottom">
            <p>&copy; {new Date().getFullYear()} DRE Pro. Todos os direitos reservados.</p>
          </div>
        </footer>

        {/* Calendly Modal */}
        {showCalendlyModal && <CalendlyModal onClose={closeCalendlyModal} />}

        {/* Email Input Modal */}
        <EmailInputModal 
          isOpen={showEmailModal}
          onClose={closeEmailModal}
          onSubmit={handleEmailSubmit}
          loading={loading}
          emailError={emailError}
        />
      </div>
    </div>
  );
};

export default LandingPage;